import Lightbox from "react-image-lightbox";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  setPhotoIndex: (value: number) => void;
  images: string[];
  photoIndex: number;
}

const LightBox = ({
  images,
  photoIndex,
  setPhotoIndex,
  isOpen,
  onClose,
}: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Lightbox
      mainSrc={images[photoIndex]}
      nextSrc={images[(photoIndex + 1) % images.length]}
      prevSrc={images[(photoIndex + images.length - 1) % images.length]}
      onCloseRequest={onClose}
      onMovePrevRequest={() =>
        setPhotoIndex((photoIndex + images.length - 1) % images.length)
      }
      onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
    />
  );
};

export default LightBox;
